module.exports = __webpack_public_path__ + "img/horizontal_6_1_9005.9a590962.png";